const sheet_url = "https://cdn.shopify.com/s/files/1/0025/2608/5179/files/Series_Information.csv?42565";

var getVimeoThumb = function(videoID){

  return new Promise(function(resolve, reject) {

    var xhr = new XMLHttpRequest();
    xhr.open("GET", "https://vimeo.com/api/v2/video/"+ videoID +".json", true);
    xhr.onload = function (e) {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          var data = xhr.responseText;
          var parsedData = JSON.parse(data);

          var html = "<div data-source='vimeo' data-video-id='"+ videoID +"'  onclick=getBox_collection(this) class='videoThumb'><img src='"+ parsedData[0].thumbnail_medium +"'></div>";
          resolve(html);

        } else {
          reject;
        }
      }
    };
    xhr.onerror = reject;
    xhr.send(null);

  });

}         

/* Method to load a particular section (not using it for now) */
Shopify.theme.sections.register('static-salesforce-form', {
  onLoad: function() {

  }
});

// call the registered method
Shopify.theme.sections.load('static-salesforce-form');
/* Method End */

$(document).ready(function(){
  
  var window_width = $(window).width();
  
  $( window ).resize(function() {
    
    var width_diff = $(window).width() - window_width;
    
    window_width = $(window).width();
    
    //console.log(width_diff);
    //console.log(Math.abs(width_diff));
    
    if( Math.abs(width_diff) > 200){
      see_more();
    }
    
    //console.log($(".collection_see_more").height());
    
  });
  
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
    }
  }

  d3.text(sheet_url, function(data) {
    var parsedCSV = d3.csv.parseRows(data);

    // get the collection title parse into division and series
    var collection_title = settings.collection_title.split("-") ;

    
    var division = collection_title[0].trim();
    
    collection_title.splice(0,1);
    
    var series = collection_title.join('-').trim();

    // take headers in a variable
    var headers = parsedCSV[0];

    // initialise variables	
    var videos = '', iframe = '', brochure = '', video_max = 3, brochure_max = 5;

    // deleting header from CSV
    delete parsedCSV[0];

    for(var i=1; i < parsedCSV.length; i++){

      // making header as key and value format


      var merged =  parsedCSV[i].reduce(function(result, field, index) {
        result[headers[index]] = field;
        return result;
      }, {})		

      //console.log(collection_title);
      console.log(series);
      
      //console.log(merged);	

      if(merged['Series'].trim() == series && merged['Division'].trim() == division){
        
        
        //console.log(merged);

        // embed videos and brocher links
        for(var k = 1; k<= video_max; k++){


          // get video ID from URL
          var videoId = merged['Video ' + k].substring(merged['Video ' + k].lastIndexOf('/') + 1);

          if(merged['Video ' + k].indexOf("youtube") !== -1){

            // remove rel query string if present
            videos += "<div data-source='youtube' data-video-id='"+ videoId.replace("?rel=0", "") +"' data-product-image-index='"+ k +"' onclick=getBox_collection(this) class='videoThumb'><img src='https://img.youtube.com/vi/" + videoId.replace("?rel=0", "") + "/default.jpg'></div>";

            var video_url = 'https://www.youtube.com/embed/' + videoId.replace("?rel=0", "") + '?rel=0';
            iframe += '<iframe src="'+ video_url + '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';

          }
          else if(merged['Video ' + k].indexOf("vimeo") !== -1){

            var video_url = 'https://player.vimeo.com/video/' + videoId + '?loop=1&autopause=0';
            iframe += '<iframe src="' + video_url + '" frameborder="0" allowfullscreen></iframe>';

            var index = k;
            var vimeo_videoId = videoId;

            //console.log(videoId);
            // fetching vimeo thumbnail
            getVimeoThumb(videoId).then(function(result) {
              //             vimeo_video = result;
              $(".description_video_container").append(result);

            })
            .catch(function() {

            });

          }

        }

        // embed brocher links
        for(var j = 1; j<= brochure_max; j++){

          if(merged['Attachment '+ j ] != ''){
            brochure += '<a target="_blank" href="'+ merged['Attachment '+ j ] +'">' + merged['Attachment '+ j +' Label'] + '</a>';	
          }
        }
        
        //console.log(iframe);

        $(".mobile_video_container").html(iframe);

        $(".description_video_container").html(videos);
        $(".brochure_container").html(brochure);

        // embed the description
        $(".collection_see_more").html(merged['Series Decription']);

        // show the description widget
        $(".description_from_csv").show();

        // hide the backend description if available
        $(".backend_discription").hide();

        // show see more for description
        setTimeout(function(){
          see_more();
        }, 800);

        break;

      }

    }

  });

  var see_more = function(){

    var target = $('[data-mrc]');
    
    if($(window).width() < 860){
    	
      	var description_height = $(".collection_see_more").height();      
      
      	if(target.find('.see_more_content').length !== 0){
          var description_height = $(".see_more_content").height();      
        }
      
      	if(description_height > 300){
          var container_height = 300;
        }else{
          
          var container_height = 1000000;
          
          $(".collection_see_more").html($(".see_more_content").html());
          
          //console.log(description_height);
          
        }
      	
    }else{
    	var container_height = $(".collection--information .colletion_left_siderbar").height();
    }
    
    var collection_see_more = $(".collection_see_more").height();


    if(collection_see_more > container_height){

      show_more(target, container_height);

      $(".collection_see_more").on("click", ".see_more", function(){

        $(this).replaceWith("<span class='show_less button_see_more'>Read less...</span>" )

        $(".see_more_wrapper").css({
          "height": $(".see_more_content").height()
        })

      })

      $(".collection_see_more").on("click", ".show_less", function(){

        // animate to top
        $("html, body").animate({ scrollTop: 0 });
        $(this).replaceWith("<span class='see_more button_see_more'>Read more...</span>");
        //show_more(target, container_height);
        $(".see_more_wrapper").css({
          "height": container_height,
        })
      })

    }
  }

  /*
  * Params: target container, container height
  * Set the hieght of the cointainer for see more feature
  */
  var show_more = function(target, container_height){

   	//console.log(target.find('.see_more_content').length);
    
    if(target.find('.see_more_content').length !== 0){
      var target = $('.see_more_content');
      //console.log(target.html());
    }
    
    var content = target.html();
    
    
    //console.log(container_height);
        
    //var autoHeight = $(".see_more_wrapper").height();

    $(".collection_see_more").html("<div class='see_more_wrapper'><div class='see_more_content' style='overflow: hidden;'>"+ content +"</div></div><span class='see_more button_see_more'>Read more...</span>");

    //$(".see_more_wrapper").animate({height:container_height});
    $(".see_more_wrapper").css({
      "height": container_height
    });
  }

  $(document).keydown(function (e) {
    if (e.keyCode == 37) {
      nextSlide_collection();
    } 
    else if(e.keyCode == 27){
      closeModalBox_collection();
    }
    else if (e.keyCode == 39) {
      prevSlide_collection(); 
    }
  });
  
  $(document).on("click", ".modalBox", function(e){

    //console.log(e.target);

    if(!$(e.target).is("iframe") && !$(e.target).is("a") && $(window).width() > 1024 ){
      
      //console.log("Here I am");
      
      closeModalBox_collection();	
    }
    
  })
  
  $(".device_sidebar_toggle").click(function(){

    var trigger = $(this);
    
    $( ".colletion_left_siderbar" ).slideToggle({

      start : function(){
        $(this).toggleClass("active");
        trigger.toggleClass("active");
      }
    });

  })

  // set pre-order if pub date is greater then current date
  if(typeof pubDate != 'undefined' && pubDate != ''){
  	
	set_preorder(pubDate, $(".product--container .product-form--atc-button .atc-button--text"));
    
  }


  $(".tag_container nav .pf-anchor").click(function(e){

    e.preventDefault();
    
    // set hash value in URL
    window.location.hash = $(this).attr("href");
    
    // set active class to show border
	$(".tag_container nav .pf-anchor").removeClass("active");
    $(this).addClass("active");
    
    // show/hide the collections
    var trigger_val = $(this).attr("href");
    
    if(trigger_val == 'all'){
      $(".tab_results .series_listing").show();
      
      hide_duplicate_series();
      
      $(".button_learning").hide();
    }else{
      $(".tab_results .series_listing").hide();
      $(".tab_results .series_listing[data-learning-area="+$(this).attr("href")+"]").show();
    }
  });
  
  hide_duplicate_series();
  
  // take the URL hash
  
  var hash_value = window.location.hash;
  if(hash_value && hash_value != '') {
    set_hash_tab(hash_value.replace("#", ""));
  }
  
  
  var alphabeticallyOrderedDivs = $('.series_listing').sort(function(a, b) {
    if(typeof $(a).data('series') != "undefined"  && typeof $(b).data('series') != "undefined"){
      return String.prototype.localeCompare.call($(a).data('series').toLowerCase(), $(b).data('series').toLowerCase());
    }
  });
    
  // sort in alphabetically order
  var $wrapper = $('.tab_results');
  
  $wrapper.detach().empty().append(alphabeticallyOrderedDivs);
  
  $(".tag_container").append($wrapper);
  
  
});

var set_hash_tab = function(selected_tab){
	
  	
	$(".tag_container nav .pf-anchor[href='"+selected_tab+"']").click();  

}

var hide_duplicate_series = function(){
	
  var series_array = new Array();
  var series_handle = "";
  
  $(".tab_results .series_listing").each(function(){
  	
    series_handle = $(this).data("series");
    if(series_array.indexOf(series_handle) < 0){series_array.push(series_handle);}else{
      $(this).hide();    
    }
  })
  
	
}

var set_preorder = function(pubDate, target){
    
    var split_date = pubDate.split('/');
    
    var pub_date_object = new Date(split_date[2], split_date[1] - 1, split_date[0]);
	var current_date_object = new Date();
    
    if(pub_date_object.getTime() > current_date_object.getTime()) {
      target.html(settings.pre_order);
    } 
    
    console.log(pubDate);
   
  }

/*
function used to show/hide fields as per the customer type
*/
var trigger_customer_type = function(customer_type){

  // unset the school validation for all cases initially
  $(".school_name input").attr("required", false);

  switch (customer_type) {
    case 'School':

      // make school required field
      $(".school_name input").attr("required", '');

      // change the optional text field
      $(".school_name label").html("School");

      // show school related fields
      $(".school_name, .ubd_number, .title_position").parent(".customr-container-item").show();

      break;

    case 'Teacher':

      // change to optional text field
      $(".school_name label").html("School (optional)");

      $(".school_name, .title_position").parent(".customr-container-item").show();
      $(".ubd_number").val('').parent(".customr-container-item").hide();

      break;

    case 'Other':

      $(".title_position").parent(".customr-container-item").show();
      $(".school_name, .ubd_number").val('').parent(".customr-container-item").hide();

      break;

    default:

      $(".school_name, .ubd_number, .title_position").val('').parent(".customr-container-item").hide();
  }

}

// check validation on update/create address in my account
$(document).on("submit", ".account-address-form.visible .customer_create_new" , function(){

  // get the city value
  let city = $(this).find(".address_city").val();

  // check for the special character in city
  if(!is_special_character_free(city)){

    // pass the target to set the error message
    let error_target = $(this).find(".address_city");

    set_city_error(error_target);

    // focus city field only in case of submit button
    $(error_target).focus();

    return false;

  }else{

    // if no error, remove the error message
    $('.city_error').remove();

  }

})

$(document).on("blur", ".account-address-form.visible .customer_create_new .address_city" , function(){

  // get the city value
  let city = $(this).val();

  if(!is_special_character_free(city)){

    // set city error message
    set_city_error(this);

  }else{

    // if no error, remove the error message
    $('.city_error').remove();

  }

})

/*
function used to check for the special charater
param: value (field value)
*/
var is_special_character_free = function(value){

  const regex = /^[a-zA-Z0-9\s]*$/i;

  return regex.test(value);

}
/*
function used to set the city error message
param: target (element where need to set the error)
*/
var set_city_error = function(target){

  // set the error
  if($('.city_error').length <= 0){

    // set "error" class to the city field
    // create & set error message
    $(target).addClass("error").parent(".form-field").append("<p class='city_error'>Special charaters are not allowed for this field.</p>");

                                                             }
                                                             }


